// header.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PersonName } from '../../person/models/person';

@Injectable({ providedIn: 'root' })
export class NavbarService {
  private _name = new BehaviorSubject<string>('');  // standaard lege naam
  /** Observable waar de header-component op abonneert */
  readonly name = this._name.asObservable();

  /** zet een nieuwe naam */
  setName(name: string) {
    this._name.next(name);
  }

  setPersonName(person: PersonName) {
    if (person)
      this.setName(person.FirstName + " " + person.LastName)
  }
}
